var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10028_77752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.802 14.032C4.19 14.274 4.835 14.543 5.517 14.543C6.138 14.543 6.715 14.363 7.193 14.056C7.193 14.056 7.194 14.056 7.195 14.055L9 12.927V17C8.714 17 8.426 16.922 8.176 16.766L3.802 14.032Z",
    fill: "#225086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.853 1.507L0.352996 9.967C-0.226004 10.621 -0.0750036 11.609 0.675996 12.078C0.675996 12.078 3.452 13.813 3.802 14.032C4.19 14.274 4.835 14.543 5.517 14.543C6.138 14.543 6.715 14.363 7.193 14.056C7.193 14.056 7.194 14.056 7.195 14.055L9 12.927L4.636 10.199L9.001 5.275V1C8.577 1 8.153 1.169 7.853 1.507Z",
    fill: "#66DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63599 10.1989L4.68799 10.2309L8.99999 12.9269H9.00099V5.2759L8.99999 5.2749L4.63599 10.1989Z",
    fill: "#CBF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.324 12.078C18.075 11.609 18.226 10.621 17.647 9.967L12.726 4.416C12.329 4.231 11.884 4.125 11.413 4.125C10.488 4.125 9.66098 4.524 9.11098 5.151L9.00198 5.274L13.366 10.198L9.00098 12.926V16.999C9.28798 16.999 9.57398 16.921 9.82398 16.765L17.324 12.077V12.078Z",
    fill: "#074793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.001 1V5.275L9.11 5.152C9.66 4.525 10.487 4.126 11.412 4.126C11.884 4.126 12.328 4.233 12.725 4.417L10.146 1.508C9.847 1.17 9.423 1.001 9 1.001L9.001 1Z",
    fill: "#0294E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.365 10.1989L9.00098 5.27588V12.9259L13.365 10.1989Z",
    fill: "#96BCC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10028_77752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntraIcon);
export default __webpack_public_path__ + "static/media/entra-icon.fab2037a3e2a21196d390bdfe07b0944.svg";
export { ForwardRef as ReactComponent };